export default "__VITE_ASSET__CX7xT_JZ__"